"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TransferPalletActionType = void 0;
var TransferPalletActionType;
(function (TransferPalletActionType) {
    TransferPalletActionType["CREATE_PALLET"] = "CREATE_PALLET";
    TransferPalletActionType["SCAN_OPEN_PALLET"] = "SCAN_OPEN_PALLET";
    TransferPalletActionType["SCAN_CLOSED_PALLET"] = "SCAN_CLOSED_PALLET";
    TransferPalletActionType["GENERATE_PALLET_ZPL"] = "GENERATE_PALLET_ZPL";
    TransferPalletActionType["GENERATE_PALLET_PDF"] = "GENERATE_PALLET_PDF";
    TransferPalletActionType["ADD_CDSKU_TO_PALLET"] = "ADD_CDSKU_TO_PALLET";
    TransferPalletActionType["REMOVE_CDSKU_FROM_PALLET"] = "REMOVE_CDSKU_FROM_PALLET";
    TransferPalletActionType["CLOSE_PALLET"] = "CLOSE_PALLET";
    TransferPalletActionType["DECLINE_CLOSE_PALLET"] = "DECLINE_CLOSE_PALLET";
    TransferPalletActionType["UPDATE_TRACKING_PALLET"] = "UPDATE_TRACKING_PALLET";
    TransferPalletActionType["SHIP_PALLET"] = "SHIP_PALLET";
    TransferPalletActionType["MARK_DELIVERED_PALLET"] = "MARK_DELIVERED_PALLET";
    TransferPalletActionType["REOPEN_PALLET"] = "REOPEN_PALLET";
    TransferPalletActionType["FC_ARRIVAL_SCAN_PALLET"] = "FC_ARRIVAL_SCAN_PALLET";
    TransferPalletActionType["HUB_ARRIVAL_SCAN_PALLET"] = "HUB_ARRIVAL_SCAN_PALLET";
    TransferPalletActionType["REROUTE_PALLET"] = "REROUTE_PALLET";
    TransferPalletActionType["UPDATE_MILK_RUN_PALLET"] = "UPDATE_MILK_RUN_PALLET";
})(TransferPalletActionType = exports.TransferPalletActionType || (exports.TransferPalletActionType = {}));
//# sourceMappingURL=TransferPalletActionType.js.map